import * as React from 'react';
import { DefaultButton, Dialog, DialogFooter, DialogType, PrimaryButton } from '@fluentui/react';
import { LieferantenrechnungPosition, deleteLieferantenrechnungPosition } from 'api/lieferantenrechnungPosition';
import { SavingState } from 'api/savingState';
import { formStyles } from 'styles/formStyles';

interface LieferantenrechnungPositionDeleteProps {
    lieferantenrechnungPosition: LieferantenrechnungPosition;
    onClose: (refetch: boolean) => void;
}

export const LieferantenrechnungPositionDelete: React.FC<LieferantenrechnungPositionDeleteProps> = ({
    lieferantenrechnungPosition,
    onClose,
}) => {
    const [savingState, setSavingState] = React.useState(SavingState.notChanged);

    const onDelete = () => {
        if (lieferantenrechnungPosition && savingState !== SavingState.saving) {
            setSavingState(SavingState.saving);
            deleteLieferantenrechnungPosition(lieferantenrechnungPosition)
                .then(() => {
                    setSavingState(SavingState.saved);
                    onClose(true);
                })
                .catch((error) => {
                    console.error(error);
                    setSavingState(SavingState.error);
                });
        }
    };

    return (
        <Dialog
            hidden={false}
            dialogContentProps={{
                title: 'Lieferantenrechnungsposition löschen',
                subText: 'Lieferantenrechnungsposition "' + lieferantenrechnungPosition.posText + '" löschen?',
                type: DialogType.normal,
            }}
        >
            {savingState === SavingState.error && <div className={formStyles.error}>Fehler beim Löschen.</div>}

            <DialogFooter>
                {savingState !== SavingState.saving && (
                    <DefaultButton
                        onClick={() => {
                            onClose(false);
                        }}
                        text="Abbrechen"
                    />
                )}

                {savingState === SavingState.saving ? (
                    <DefaultButton text="Lösche..." disabled />
                ) : (
                    <PrimaryButton
                        onClick={onDelete}
                        text="Löschen"
                        disabled={savingState !== SavingState.notChanged}
                    />
                )}
            </DialogFooter>
        </Dialog>
    );
};
